import {Component, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import FileSaver from "file-saver";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-invoice-report-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./invoice-report-page.component.html",
    standalone: false
})
export class InvoiceReportPageComponent implements OnInit {


    type: string;

    description: string = " ";


    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private route: ActivatedRoute,
        private router: Router) {

    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.type = params.get("type");
            this.description = "Chewzie Invoices";
            if (this.type !== "chewzie") {
                this.type = "fedelta";
                this.description = "Fedelta Invoices";
            }


        });
    }

    done(): void {
        this.router.navigate(["/main/customer-search/" + this.type]);
    }


    downloadReport(): void {
        this.spinnersService.open();
        this.http.post("/fonzie/generate-invoice-report", {type: this.type}, {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "blob"
        })
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe((data) => {
                this.spinnersService.close();
                FileSaver.saveAs(data, "invoices-" + this.type + ".csv");
            });
    }

}
